import type { Dispatch, FC, SetStateAction } from 'react';
import React from 'react';
import MultipleChoiceSelection from './MultipleChoiceSelection';
import SingleChoiceSelection from './SingleChoiceSelection';
import QuantitySelection from './QuantitySelection';
import type { OptionGroupDto } from '../../../../../generated-api';
import type { CartAdditionOption } from '../../../../../types/cart';

interface Props {
  optionGroup: OptionGroupDto;
  setOptions: Dispatch<SetStateAction<CartAdditionOption[]>>;
  defaultOptions: CartAdditionOption[];
}

const OptionsSelection: FC<Props> = (props) => {
  switch (props.optionGroup.selectionType) {
    case 'MULTIPLE_CHOICE': {
      return <MultipleChoiceSelection {...props} />;
    }
    case 'SINGLE_CHOICE': {
      return <SingleChoiceSelection {...props} />;
    }
    case 'QUANTITY': {
      return <QuantitySelection {...props} />;
    }
    default: {
      throw new Error('No selection type defined for option group');
    }
  }
};
export default OptionsSelection;
